import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse,
} from '@angular/common/http';
import { catchError, Observable, throwError } from 'rxjs';
import { OAuthService } from 'angular-oauth2-oidc';
import { environment } from '../../../environments/environment';

@Injectable()
export class TokenInterceptorService implements HttpInterceptor {
  constructor(private authService: OAuthService) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    const token = this.authService.getAccessToken();

    if (token && this.isEsspApi(request.url)) {
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`,
          Accept: 'application/json',
        },
      });
    }

    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        console.error('HttpErrorResponse:', error);
        console.error('error.error:', error.error);
        console.error('error.text:', error.error?.text);

        return throwError(() => error);
      }),
    );
  }

  isEsspApi(url: string): boolean {
    return [
      environment.salesNavBackendUrl,
      environment.portalHomeUrl,
      environment.portalMetaBackendUrl,
    ].some((api) => url.startsWith(api));
  }
}
